import React, { useEffect, useState } from "react";

const urlPayment = "/paymentconfig.json"; // ✅ Local JSON Path

const PaymentDue = () => {
  const [paymentData, setPaymentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [serverError, setServerError] = useState(false);

  useEffect(() => {
    const fetchPaymentData = async () => {
      try {
        const response = await fetch(urlPayment);
        
        if (!response.ok) {
          throw new Error("Server Down due to Payment Due");
        }

        const data = await response.json();
        console.log("📥 Payment Data Loaded:", data); // ✅ Debugging
        setPaymentData(data);
      } catch (error) {
        console.error("❌ Error fetching payment data:", error);
        setServerError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentData();
  }, []);

  if (loading) {
    return <div className="text-center text-lg p-10">⏳ Loading Payment Details...</div>;
  }

  if (serverError) {
    return (
      <div className="flex flex-col justify-center items-center h-screen bg-gray-100 p-6">
        <div className="w-full max-w-lg bg-white p-6 rounded-lg shadow-lg text-center">
          <h1 className="text-3xl font-bold text-red-600 mb-4">🚨 Server Down! 🚨</h1>
          <p className="text-lg text-gray-700 mb-6">
            <span className="text-red-600 font-bold">{paymentData?.customer_name || "ग्राहक"}</span>,  
            आपके पेमेंट ड्यू के कारण हमारी सर्विस अस्थायी रूप से बंद कर दी गई है। 
            कृपया जल्द से जल्द भुगतान करें।
          </p>

          {/* Contact Information */}
          <div className="mt-6 text-gray-700">
            <p className="text-lg font-semibold">📞 Call Us:</p>
            <p className="text-blue-600 font-bold">
              <a href="tel:+918821861409">+91-88218-61409</a>,  
              <a href="tel:+917000864390"> +91-70008-64390</a>
            </p>

            <p className="mt-2 text-lg font-semibold">📧 Mail Us:</p>
            <p className="text-blue-600 font-bold">
              <a href="mailto:info@niketgroup.in">info@niketgroup.in</a>
            </p>

            <p className="mt-2 text-lg font-semibold">📍 Address:</p>
            <p className="text-gray-800">
              22, Chhindwara, Madhya Pradesh, INDIA, 480001
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (!paymentData) {
    return <div className="text-center text-lg p-10 text-red-600">❌ Error fetching payment data!</div>;
  }

  return (
    <div className="flex flex-col justify-center items-center min-h-screen bg-red-100 p-6">
      <div className="w-full max-w-lg bg-white p-6 rounded-lg shadow-lg text-center">
      <h1 className="text-3xl font-bold text-red-600 mb-4">🚨 Server Down! 🚨</h1>
          <p className="text-lg text-gray-700 mb-6">
            <span className="text-red-600 font-bold">{paymentData?.customer_name || "ग्राहक"}</span>,  
            आपके पेमेंट ड्यू के कारण हमारी सर्विस अस्थायी रूप से बंद कर दी गई है। 
            कृपया जल्द से जल्द भुगतान करें।
          </p>
          
        <h1 className="text-3xl font-bold text-red-600 mb-4">🚨 Payment Due! 🚨</h1>
        <p className="text-lg text-gray-700 mb-4">
          <span className="text-red-600 font-bold">{paymentData.customer_name}</span>,  
          आपकी सेवा अस्थायी रूप से बंद कर दी गई है क्योंकि आपके खाते में  
          <span className="text-red-600 font-bold"> ₹{paymentData.payment_amount} </span>  
          का भुगतान लंबित है। कृपया <span className="font-bold text-red-600">{paymentData.due_date}</span> से पहले भुगतान करें।
        </p>

        <p className="text-lg text-gray-700 mb-6">
          भुगतान करने के बाद, सेवा स्वचालित रूप से फिर से शुरू हो जाएगी।
        </p>

        {/* UPI QR Code */}
        <div className="bg-white p-4 rounded-lg shadow-md inline-block">
          <img src={paymentData.qr_code} alt="QR Code for UPI Payment" className="w-48 h-48" />
        </div>

        <p className="mt-4 text-lg font-semibold">
          📌 UPI ID: <span className="text-blue-600">{paymentData.upi_id}</span>
        </p>

        {/* Pay Now Button */}
        <a
          href={paymentData.payment_link}
          className="mt-6 bg-green-500 text-white px-6 py-3 rounded-md text-lg font-semibold hover:bg-green-600 transition block"
        >
          💰 Pay Now
        </a>

        {/* Contact Information */}
        <div className="mt-6 text-gray-700">
          <p className="text-lg font-semibold">📞 Call Us:</p>
          <p className="text-blue-600 font-bold">
            <a href="tel:+918821861409">+91-88218-61409</a>,  
            <a href="tel:+917000864390"> +91-70008-64390</a>
          </p>

          <p className="mt-2 text-lg font-semibold">📧 Mail Us:</p>
          <p className="text-blue-600 font-bold">
            <a href="mailto:info@niketgroup.in">info@niketgroup.in</a>
          </p>

          <p className="mt-2 text-lg font-semibold">📍 Address:</p>
          <p className="text-gray-800">
            22, Chhindwara, Madhya Pradesh, INDIA, 480001
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentDue;
